import { Close, Icon } from "@shared/ui";
import { createPortal } from "react-dom";

import ButtonPrimary from "./ButtonPrimary";
import ButtonSecondary from "./ButtonSecondary";

/**
 * Modal for confirming policy action execution
 * @param {boolean} isOpen - Whether the modal is open
 * @param {Function} onClose - Function to close the modal
 * @param {Object} action - The policy action being executed
 * @param {Function} onConfirm - Function to call when confirming the action
 */
const PolicyActionConfirmModal = ({ isOpen, onClose, action, onConfirm }) => {
  const handleConfirm = (e) => {
    e.preventDefault();
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  if (!isOpen || !action) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">
            Confirm Action
          </h2>
          <button
            onClick={onClose}
            className="p-1 rounded hover:bg-gray-100 focus:outline-none"
            aria-label="Close"
          >
            <Icon icon={Close} className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-6">
            <p className="text-sm text-gray-700 mb-4">
              {action.confirmationMessage}. Are you sure you want to proceed?
            </p>
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-x-3">
            <ButtonSecondary text="Cancel" onClick={onClose} type="button" />
            <ButtonPrimary
              text="Confirm"
              onClick={handleConfirm}
              type="button"
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PolicyActionConfirmModal;
